export class PMNaMaTreeNode {
    constructor(id, code, displayString, isLeaf) {
        let that = this;
        that.id = id;
        that.displayString = displayString;
        that.code = code;
        that.items = [];
        that.isLeaf = isLeaf === true;
    }

    addChild(node) {
        let that = this;
        if (!that.items)
            that.items = [];
        let childAdded = false;
        for (let i = 0; i < that.items.length; i++) {
            if (that.items[i].code.toLowerCase().localeCompare(node.code.toLowerCase()) >= 0) {
                childAdded = true;
                that.items.splice(i, 0, node);
                break;
            }
        }
        if (!childAdded)
            that.items.push(node);
        node.parentID = that.id;
    }
}